export default {
    'name': 'caret',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M19.5429 16.7276C19.9334 17.1181 20.5666 17.1181 20.9571 16.7276C21.3476 16.337 21.3476 15.7039 20.9571 15.3133L12.6867 7.04289C12.2961 6.65237 11.663 6.65237 11.2724 7.04289L3.00198 15.3133C2.61146 15.7039 2.61146 16.337 3.00198 16.7276C3.39251 17.1181 4.02567 17.1181 4.41619 16.7276L11.9795 9.16421L19.5429 16.7276Z\' fill=\'#FF4171\'/>'
}
